import React from 'react';
import { Link } from 'react-router-dom';
import { ArrowRight } from 'lucide-react';

interface CTABoxProps {
  title: string;
  description: string;
  buttonText: string;
  buttonLink: string;
}

const CTABox: React.FC<CTABoxProps> = ({ title, description, buttonText, buttonLink }) => {
  return (
    <div className="cta-box">
      <h3>{title}</h3>
      <p>{description}</p>
      <Link to={buttonLink} className="cta-button">
        {buttonText} <ArrowRight className="size-4" aria-hidden="true" />
      </Link>
    </div>
  );
};

export default CTABox;